import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  href,
  variant = 'primary',
  children,
  className = '',
  fullWidth = false,
  onClick,
  ...props
}: ButtonProps) {
  const widthStyles = fullWidth ? 'w-full' : '';
  const baseClass = variant === 'primary' ? 'btn-principal btn-dorado' : 'btn-principal';
  const cls = `${baseClass} ${widthStyles} ${className}`;
  if (href) {
    return <a href={href} className={cls} onClick={onClick as any} data-id="element-291">
        <span className="relative z-10" data-id="element-292">{children}</span>
      </a>;
  }
  return <button className={cls} onClick={onClick} {...props as any} data-id="element-293">
      <span className="relative z-10" data-id="element-294">{children}</span>
    </button>;
}